import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-international-trading-policy';

export default function Example() {
  return (
    <>
      <Head>
        <title>Selling Internationally on eBay? Here’s What You Need To Know</title>
        <meta
          name='description'
          content='Gaining extensive exposure through international sales can help boost your earnings, but these are policies you must watch out for before closing any transactions.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-international-trading-policy' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-international-trading-policy' />
        <meta property='og:title' content='Selling Internationally on eBay? Here’s What You Need To Know' />
        <meta
          property='og:description'
          content='Gaining extensive exposure through international sales can help boost your earnings, but these are policies you must watch out for before closing any transactions.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
